import TextInputField from "controls/global/text-input-field";
import React, { useEffect, useRef, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface Props {
  name: string;
  errorMaxLength: number;
  onErrorChange?: (hasError: boolean) => void;
  validateOnChange?: boolean;
  [key: string]: any;
}

const SpecialTextInputField = (props: Props) => {
  const { name, errorMaxLength, validateOnChange, onErrorChange, ...rest } = props;
  const { control, clearErrors, trigger } = useFormContext();

  const value = useWatch({ control, name });
  const [instanceKey, setInstanceKey] = useState(0);
  const prevOverLimitRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (typeof errorMaxLength !== "number") return;
    if (!validateOnChange) return;

    const str =
      typeof value === "string"
        ? value
        : value == null
        ? ""
        : String(value);

    const isOver = str.length > errorMaxLength;
    const prev = prevOverLimitRef.current;

    if (prev !== isOver) {
      onErrorChange?.(isOver);

      if (prev === true && isOver === false) {
        setInstanceKey((k) => k + 1); 
        clearErrors(name);           
        trigger(name);
      }

      prevOverLimitRef.current = isOver;
    }
  }, [value, errorMaxLength, validateOnChange, onErrorChange, clearErrors, trigger, name]);

  return (
    <TextInputField
      key={instanceKey}
      name={name}
      errorMaxLength={errorMaxLength}
      validateOnChange={validateOnChange}
      onErrorChange={onErrorChange}
      {...rest}
    />
  );
};

export default SpecialTextInputField;
